<ng-container *ngIf="gdprModalConfig$ | async as gdprModalConfig">
    <div class="container-fluid gdpr-modal">
        <div class="row">
            <div class="col-12">
                <h3>
                    {{ gdprModalConfig.title }}
                </h3>
            </div>
            <div class="col-12 d-md-block d-none">
                <div class="d-flex">
                    <div class="navigation">
                        <serviceos-ng-menu>
                            <serviceos-ng-menu-item
                                (click)="
                                    changePanel({ panelId: 'how_it_work' })
                                "
                                [ngClass]="{
                                    active: activeScreen === 'how_it_work'
                                }"
                            >
                                {{ gdprModalConfig.how_it_work.title }}
                            </serviceos-ng-menu-item>
                            <serviceos-ng-menu-item
                                (click)="changePanel({ panelId: 'essential' })"
                                [ngClass]="{
                                    active: activeScreen === 'essential'
                                }"
                            >
                                {{ gdprModalConfig.essential.title }}
                            </serviceos-ng-menu-item>
                            <serviceos-ng-menu-item
                                (click)="
                                    changePanel({ panelId: 'performance' })
                                "
                                [ngClass]="{
                                    active: activeScreen === 'performance'
                                }"
                            >
                                {{ gdprModalConfig.performance.title }}
                            </serviceos-ng-menu-item>
                            <serviceos-ng-menu-item
                                (click)="changePanel({ panelId: 'functional' })"
                                [ngClass]="{
                                    active: activeScreen === 'functional'
                                }"
                            >
                                {{ gdprModalConfig.functional.title }}
                            </serviceos-ng-menu-item>
                            <serviceos-ng-menu-item
                                (click)="
                                    changePanel({ panelId: 'advertising' })
                                "
                                [ngClass]="{
                                    active: activeScreen === 'advertising'
                                }"
                            >
                                {{ gdprModalConfig.advertising.title }}
                            </serviceos-ng-menu-item>
                            <serviceos-ng-menu-item (click)="cookiePolicy()">
                                {{ gdprModalConfig.more.title }}
                            </serviceos-ng-menu-item>
                        </serviceos-ng-menu>
                    </div>
                    <div class="gdpr-content">
                        <div class="content">
                            <ng-container [ngSwitch]="activeScreen">
                                <ng-container *ngSwitchCase="'how_it_work'">
                                    <div
                                        [innerHtml]="
                                            gdprModalConfig.how_it_work
                                                .content_html | trustContent
                                        "
                                    ></div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'essential'">
                                    <div
                                        class="d-flex justify-content-end control"
                                    >
                                        <span>{{
                                            gdprModalConfig.essential.active
                                        }}</span>
                                        <serviceos-ng-slide-toggle
                                            [hideLabel]="true"
                                            [checked]="true"
                                            [disabled]="true"
                                        ></serviceos-ng-slide-toggle>
                                    </div>
                                    <div
                                        [innerHtml]="
                                            gdprModalConfig.essential
                                                .content_html | trustContent
                                        "
                                    ></div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'performance'">
                                    <div
                                        class="d-flex justify-content-end control"
                                    >
                                        <span>{{
                                            preferences.performanceCookies
                                                ? gdprModalConfig.performance
                                                      .configurable.active
                                                : gdprModalConfig.performance
                                                      .configurable.inactive
                                        }}</span>
                                        <serviceos-ng-slide-toggle
                                            [hideLabel]="true"
                                            [(ngModel)]="
                                                preferences.performanceCookies
                                            "
                                        ></serviceos-ng-slide-toggle>
                                    </div>
                                    <div
                                        [innerHtml]="
                                            gdprModalConfig.performance
                                                .content_html | trustContent
                                        "
                                    ></div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'functional'">
                                    <div
                                        class="d-flex justify-content-end control"
                                    >
                                        <span>{{
                                            preferences.functionalCookies
                                                ? gdprModalConfig.functional
                                                      .configurable.active
                                                : gdprModalConfig.functional
                                                      .configurable.inactive
                                        }}</span>
                                        <serviceos-ng-slide-toggle
                                            [hideLabel]="true"
                                            [(ngModel)]="
                                                preferences.functionalCookies
                                            "
                                        ></serviceos-ng-slide-toggle>
                                    </div>
                                    <div
                                        [innerHtml]="
                                            gdprModalConfig.functional
                                                .content_html | trustContent
                                        "
                                    ></div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'advertising'">
                                    <div
                                        class="d-flex justify-content-end control"
                                    >
                                        <span>{{
                                            preferences.targetingCookies
                                                ? gdprModalConfig.advertising
                                                      .configurable.active
                                                : gdprModalConfig.advertising
                                                      .configurable.inactive
                                        }}</span>
                                        <serviceos-ng-slide-toggle
                                            [hideLabel]="true"
                                            [(ngModel)]="
                                                preferences.targetingCookies
                                            "
                                        ></serviceos-ng-slide-toggle>
                                    </div>
                                    <div
                                        [innerHtml]="
                                            gdprModalConfig.advertising
                                                .content_html | trustContent
                                        "
                                    ></div>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 d-md-none">
                <ngb-accordion
                    #accordionMobile
                    [closeOthers]="true"
                    [activeIds]="activeScreen"
                    (panelChange)="changePanel($event)"
                >
                    <ngb-panel cardClass id="how_it_work">
                        <ng-template ngbPanelHeader>
                            <button class="collapse-header" ngbPanelToggle>
                                <span class="title">
                                    {{ gdprModalConfig.how_it_work.title }}
                                </span>
                                <span class="toggle-btn" *ngIf="moduleCustomerTexts$ | async as moduleCustomerTexts">
                                    {{
                                        activeScreen === 'how_it_work' ? moduleCustomerTexts.hide : moduleCustomerTexts.view
                                    }}
                                </span>
                            </button>
                        </ng-template>
                        <ng-template ngbPanelContent>
                            <div
                                [innerHtml]="
                                    gdprModalConfig.how_it_work.content_html
                                        | trustContent
                                "
                            ></div>
                        </ng-template>
                    </ngb-panel>
                    <ngb-panel id="essential">
                        <ng-template ngbPanelHeader>
                            <button class="collapse-header" ngbPanelToggle>
                                <span class="title">
                                    {{ gdprModalConfig.essential.title }}
                                </span>
                                <span class="toggle-btn" *ngIf="moduleCustomerTexts$ | async as moduleCustomerTexts">
                                    {{
                                        activeScreen === 'essential' ? moduleCustomerTexts.hide : moduleCustomerTexts.view
                                    }}
                                </span>
                            </button>
                        </ng-template>
                        <ng-template ngbPanelContent>
                            <div class="d-flex justify-content-end control">
                                <span>{{
                                    gdprModalConfig.essential.active
                                }}</span>
                                <serviceos-ng-slide-toggle
                                    [hideLabel]="true"
                                    [checked]="true"
                                    [disabled]="true"
                                ></serviceos-ng-slide-toggle>
                            </div>
                            <div
                                [innerHtml]="
                                    gdprModalConfig.essential.content_html
                                        | trustContent
                                "
                            ></div>
                        </ng-template>
                    </ngb-panel>
                    <ngb-panel id="performance">
                        <ng-template ngbPanelHeader>
                            <button class="collapse-header" ngbPanelToggle>
                                <span class="title">
                                    {{ gdprModalConfig.performance.title }}
                                </span>
                                <span class="toggle-btn" *ngIf="moduleCustomerTexts$ | async as moduleCustomerTexts">
                                    {{
                                        activeScreen === 'performance'
                                            ? moduleCustomerTexts.hide
                                            : moduleCustomerTexts.view
                                    }}
                                </span>
                            </button>
                        </ng-template>
                        <ng-template ngbPanelContent>
                            <div class="d-flex justify-content-end control">
                                <span>{{
                                    preferences.performanceCookies
                                        ? gdprModalConfig.performance
                                              .configurable.active
                                        : gdprModalConfig.performance
                                              .configurable.inactive
                                }}</span>
                                <serviceos-ng-slide-toggle
                                    [hideLabel]="true"
                                    [(ngModel)]="preferences.performanceCookies"
                                ></serviceos-ng-slide-toggle>
                            </div>
                            <div
                                [innerHtml]="
                                    gdprModalConfig.performance.content_html
                                        | trustContent
                                "
                            ></div>
                        </ng-template>
                    </ngb-panel>
                    <ngb-panel id="functional">
                        <ng-template ngbPanelHeader>
                            <button class="collapse-header" ngbPanelToggle>
                                <span class="title">
                                    {{ gdprModalConfig.functional.title }}
                                </span>
                                <span class="toggle-btn" *ngIf="moduleCustomerTexts$ | async as moduleCustomerTexts">
                                    {{
                                        activeScreen === 'functional'
                                            ? moduleCustomerTexts.hide
                                            : moduleCustomerTexts.view
                                    }}
                                </span>
                            </button>
                        </ng-template>
                        <ng-template ngbPanelContent>
                            <div class="d-flex justify-content-end control">
                                <span>{{
                                    preferences.functionalCookies
                                        ? gdprModalConfig.functional
                                              .configurable.active
                                        : gdprModalConfig.functional
                                              .configurable.inactive
                                }}</span>
                                <serviceos-ng-slide-toggle
                                    [hideLabel]="true"
                                    [(ngModel)]="preferences.functionalCookies"
                                ></serviceos-ng-slide-toggle>
                            </div>
                            <div
                                [innerHtml]="
                                    gdprModalConfig.functional.content_html
                                        | trustContent
                                "
                            ></div>
                        </ng-template>
                    </ngb-panel>
                    <ngb-panel id="advertising">
                        <ng-template ngbPanelHeader>
                            <button class="collapse-header" ngbPanelToggle>
                                <span class="title">
                                    {{ gdprModalConfig.advertising.title }}
                                </span>
                                <span class="toggle-btn" *ngIf="moduleCustomerTexts$ | async as moduleCustomerTexts">
                                    {{
                                        activeScreen === 'advertising'
                                            ? moduleCustomerTexts.hide
                                            : moduleCustomerTexts.view
                                    }}
                                </span>
                            </button>
                        </ng-template>
                        <ng-template ngbPanelContent>
                            <div class="d-flex justify-content-end control">
                                <span>{{
                                    preferences.targetingCookies
                                        ? gdprModalConfig.advertising
                                              .configurable.active
                                        : gdprModalConfig.advertising
                                              .configurable.inactive
                                }}</span>
                                <serviceos-ng-slide-toggle
                                    [hideLabel]="true"
                                    [(ngModel)]="preferences.targetingCookies"
                                ></serviceos-ng-slide-toggle>
                            </div>
                            <div
                                [innerHtml]="
                                    gdprModalConfig.advertising.content_html
                                        | trustContent
                                "
                            ></div>
                        </ng-template>
                    </ngb-panel>
                    <ngb-panel id="more">
                        <ng-template ngbPanelHeader>
                            <div
                                class="collapse-header"
                                (click)="cookiePolicy()"
                            >
                                <span class="title">
                                    {{ gdprModalConfig.more.title }}
                                </span>
                            </div>
                        </ng-template>
                    </ngb-panel>
                </ngb-accordion>
            </div>
            <div class="col-12 d-flex flex-row-reverse pt-3">
                <serviceos-ng-button size="small" (click)="confirm()"
                    >{{ gdprModalConfig.confirm_button }}
                </serviceos-ng-button>
            </div>
        </div>
    </div>
</ng-container>
